import React from 'react';

function CocktailGlassIcon(props: React.ComponentProps<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M8.90579 21C8.3371 21 7.5344 20.3603 7.87688 20.01C8.86215 19.3621 9.88725 18.7724 10.9473 18.2437V11.108C10.9474 11.0745 10.9493 11.0414 10.9534 11.0081L4.31352 4.71727C4.16609 4.57754 4.06655 4.39836 4.0251 4.20366C3.98364 4.00896 4.00181 3.80731 4.08033 3.62339C4.15884 3.43948 4.29292 3.28157 4.46489 3.17055C4.63686 3.05953 4.84053 3.00063 5.04787 3H18.9597C19.1671 3.00063 19.3687 3.05953 19.5406 3.17055C19.7126 3.28157 19.8467 3.43948 19.9252 3.62339C20.0037 3.80731 20.0239 4.00896 19.9825 4.20366C19.941 4.39836 19.8394 4.57754 19.692 4.71727L13.0521 11.0081C13.0541 11.0415 13.0541 11.0746 13.0521 11.108V18.2496C14.1454 18.7168 15.1759 19.3078 16.1225 20.01C16.4723 20.5119 15.6582 21 15.0895 21H8.90579Z"/>
    </svg>
  );
}

export default CocktailGlassIcon;

